module.exports = __webpack_public_path__ + "img/img1.25092772.svg";